import { useLocation } from "react-router-dom";

const getBasePath = (pathname: string) => {
  let redirectTo = "/app/management/routes";
  if (pathname.indexOf("policies") > -1) {
    redirectTo = "/app/management/policies";
  } else if (pathname.indexOf("certificates") > -1) {
    redirectTo = "/app/management/certificates";
  } else if (pathname.indexOf("settings") > -1) {
    redirectTo = "/app/settings";
  } else if (pathname.indexOf("service-accounts") > -1) {
    redirectTo = "/app/management/service-accounts";
  } else if (pathname.indexOf("deployments") > -1) {
    redirectTo = "/app/reports/deployments";
  } else if (pathname.indexOf("usage") > -1) {
    redirectTo = "/app/reports/usage";
  }
  return redirectTo;
};

function useResetRedirect() {
  const { pathname } = useLocation();
  return getBasePath(pathname);
}
export { getBasePath, useResetRedirect };
export default useResetRedirect;
